import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-bd4264c6.js';
import './chunk-f647b5cb.js';
import './chunk-0928016a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-b59d2948.js';
import { A as Autocomplete } from './chunk-4f0d2958.js';
export { A as BAutocomplete } from './chunk-4f0d2958.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/dist/esm/autocomplete.js
// module id = 34
// module chunks = 0